import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ExperienceOverviewService } from '../experience-overview.service';
import { ExperienceOverviewViewPart } from './overview/overview-view.part';
@Component({
	selector: 'experience-overview-views-part',
	standalone: true,
	imports: [
		ExperienceOverviewViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './overview-views.part.html',
})
export class ExperienceOverviewViewsPart implements OnInit {
	public service = inject(ExperienceOverviewService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}